import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { ImageGatsby, Link, ParallaxTitle } from '../../../components'

import MarkdownText from '../../../components/MarkdownText'
import Technology from '../../../datas/models/Technology'
import { chainDecorators, memoized } from '../../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function ProjectDescription({
  description,
  technologies,
  credits,
  creditsLabel,
  technologiesLabel,
  sectorLabel,
  sector,
  tags,
  t,
  qrCode,
  link
}) {

  return (
    <div className="container">
      <ParallaxTitle title={t('projectSubtitleParallax')} parallax={{ translateY: [-70, 10] }} />
      <div className="left">
        <p className="title">{t('projectSubtitle')}</p>

        <MarkdownText
          source={description}
          className="description"
        />

        <div className="tags">
          {tags
            && tags.map(tag => (
              <p
                className="tag-content"
                key={tag}
              >
                {tag}
              </p>
            ))
          }
        </div>

        <p className="subtitle">{technologiesLabel}</p>
        <div className="technologies">
          {technologies?.map(item => (
            <p
              className="content"
              key={item.slug}
            >
              {item.features?.[0]?.title}
            </p>
          ))
          }
        </div>
        {sector
      && (
        <Fragment>
          <p className="subtitle">{sectorLabel}</p>
          <p className="content">{sector}</p>
        </Fragment>
      )
      }
        {(link || qrCode) && <>
          <Fragment>
            <p className="discover">{t('discoverLabel')}</p>
            {link && <Link link={link} target={'_blank'}>
              <div className="discover-link">
                <img className="arrow-icon" src={'/images/icons/arrow-right-white.svg'} alt={'next'} />
                <p className="linkLabel">{t('linkDiscoverLabel')}</p>
              </div>
            </Link>}
            {qrCode && <p className="qrCode"><ImageGatsby src={qrCode} /></p>}
          </Fragment>
        </>}
      </div>

      <div className="right">

        {tags
        && tags.map(tag => (
          <p
            className="tag-content"
            key={tag}
          >
            {tag}
          </p>
        ))
      }
      </div>

      <style jsx>{styles}</style>
    </div>
  )
}

ProjectDescription.propTypes = {
  description: PropTypes.string,
  technologies: PropTypes.arrayOf(Technology.propTypes).isRequired,
  technologiesLabel: PropTypes.string.isRequired,
  creditsLabel: PropTypes.string.isRequired,
  credits: PropTypes.string.isRequired,
  sectorLabel: PropTypes.string,
  sector: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  t: PropTypes.func.isRequired,
  qrCode: PropTypes.object,
  link: PropTypes.string
}

ProjectDescription.defaultProps = {
  description: '',
  sectorLabel: '',
  sector: '',
  tags: [],
}

ProjectDescription = chainDecorators(decorators, ProjectDescription)

export default ProjectDescription
